<template>
  <div>
    <div class="project-row align-items-center flex-wrap portlet-body p-0">
      <ConstructionsSearchPanel
        :search="search"
        v-on:search="this.handleSearch"
      />
      <div v-if="this.getRole !== 'subcontractor'" class="searchpanel-item">
        <router-link
          tag="a"
          to="/construction/add"
          class="btn btn-outline-primary project-select searchpanel-item mb-3"
        >
          <i class="fas fa-plus"></i> Dodaj Budowę
        </router-link>
      </div>
    </div>

    <div
      v-if="this.projects.length !== 0"
      class="d-flex align-items-center justify-content-between flex-wrap"
    >
      <p class="mb-3 mr-4">
        Ilość znalezionych budów: {{ this.projects.length }}
      </p>
      <div class="mb-3">
        <button
          class="btn btn-outline-secondary btn-layout mr-2" :class="{'active': layout === 'grid'}"
          @click="changeLayoutToGrid()"
        >
          <i class="fas fa-th-large"></i>
        </button>
        <button class="btn btn-outline-secondary btn-layout" :class="{'active': layout === 'list'}" @click="changeLayoutToList()">
          <i class="fas fa-list"></i>
        </button>
      </div>
    </div>

    <div class="row" v-show="isBusy">
      <div class="col-12">
        <TableSpiner />
      </div>
    </div>

    <div v-show="!isBusy">
      <div class="row" v-if="layout === 'grid'">
        <ConstructionPortlet
          v-for="(project, index) in projects"
          :key="index"
          :construction="project"
        />
      </div>
      <template v-else-if="layout === 'list'">
        <ConstructionList
          :constructions="projects"
        />
      </template>
    </div>

    <div class="portlet-body cs-scroll" v-if="!isBusy && projects.length === 0">
      <div class="empty">
        <i class="fas fa-home empty-state"></i>
        <span class="empty-search">Brak Budów</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import TableSpiner from "../components/TableSpiner";
import ConstructionsSearchPanel from "../components/construction/ConstructionsSearchPanel";
import ConstructionPortlet from "../components/construction/ConstructionPortlet";
import ConstructionList from "../components/construction/ConstructionList";

export default {
  name: "TheConstructions",
  components: { TableSpiner, ConstructionsSearchPanel, ConstructionPortlet, ConstructionList },
  data() {
    return {
      isBusy: false,
      layout: "grid",
    };
  },
  computed: {
    ...mapGetters("projectslist", ["search", "projects"]),
    ...mapGetters("user", ["getRole"]),
  },
  created() {
    if (this.getRole !== "subcontractor") {
      this.loadAvailableEmployees();
    } else {
      this.$store.commit("projectslist/search", {
        type: "status",
        value: ["not_started", "in_progress"],
      });
    }
  },
  methods: {
    ...mapActions("app", ["loadAvailableEmployees"]),
    ...mapActions("projectslist", ["doSearch"]),
    handleSearch(query) {
      if (this.$_.isEmpty(query) === false) {
        this.$store.commit("projectslist/search", query);
      }
      this.isBusy = true;
      this.$Progress.start();
      this.doSearch(this.search)
        .then(() => {
          this.isBusy = false;
        })
        .catch(() => {
          return [];
        });
    },
    changeLayoutToGrid() {
      this.layout = "grid";
    },
    changeLayoutToList() {
      this.layout = "list";
    },
  },
  mounted() {
    if (this.$_.isEmpty(this.projects)) {
      this.handleSearch();
    }
  },
};
</script>
